import { Subject } from '../../../../../node_modules/rxjs';
import { Injectable } from "@angular/core";

@Injectable()
export class OrganizationLocalService {

  /**
   * not really used
   */
  organizationTreeWasChanged = new Subject<boolean>();

}
